<template>
  <div class="student_tutorsAdd">
    <btn class="m-btn--column" @click.native="showModal(), $emit('set')">追加</btn>
    <component-modal v-show="condition.condition" transition="expand">

      <template slot="title">
        生徒検索
      </template>

      <div slot="body" class="wrapper">

        <div class="mail-list">
          <table-c>
            <tr-c slot="tr-th">
              <td-c><input type="text" v-model="search.id" @keyup="searchTable()" placeholder="id"></td-c>
              <td-c><input type="text" v-model="search.tel1" @keyup="searchTable()" placeholder="tel1"></td-c>
              <td-c><input type="text" v-model="search.tel2" @keyup="searchTable()" placeholder="tel2"></td-c>
              <td-c><input type="text" v-model="search.name" @keyup="searchTable()" placeholder="name"></td-c>
              <td-c><input type="text" v-model="search.kana" @keyup="searchTable()" placeholder="kana"></td-c>
            </tr-c>

            <tr-c slot="tr-td" @click.native="push(list)" v-for="(list, index) in students" :key="index.id" class="tr_hover">
              <td-c>{{list.id}}</td-c>
              <td-c>{{list.family.tel1}}</td-c>
              <td-c>{{list.family.tel2}}</td-c>
              <td-c>{{list.f_name}} {{list.l_name}}</td-c>
              <td-c>{{list.f_name_kana}} {{list.l_name_kana}}</td-c>
            </tr-c>

            <tr-c slot="tr-td">
              <th-c style="border-right: 0">追加対象</th-c>
              <th-c style="border-right: 0"></th-c>
              <th-c style="border-right: 0"></th-c>
              <th-c style="border-right: 0"></th-c>
              <th-c></th-c>
            </tr-c>

            <tr-c style="height: 25px" slot="tr-td">
              <td-c>{{student_tutor.student_id}}</td-c>
              <td-c>{{student_tutor.tel1}}</td-c>
              <td-c>{{student_tutor.tel2}}</td-c>
              <td-c>{{student_tutor.name}}</td-c>
              <td-c>{{student_tutor.kana}}</td-c>
            </tr-c>
          </table-c>
        </div>

      </div>

      <div class="footer" slot="footer">
        <!-- <btn @click.native="postST(), $emit('mdl')">追加</btn> -->
        <btn @click.native="postST">追加</btn>
        <btn @click.native="showModal">キャンセル</btn>
      </div>

    </component-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/students/search?limit=' + 5

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'student',
  pageNames: 'students'
}

export default {
  name: 'student_tutorsAdd',
  props: {
    modal: Object
  },
  data () {
    return {
      condition: {
        condition: false
      },

      student_tutor: {
        // user_id: '',
        student_id: '',
        tutor_id: 0,
        // office_id: '',
        guidance_period_start: '0001/01/01',
        guidance_period_end: '0001/01/01',
        filing_date: new Date(),
        matching_type: 0,
        matching_date: '0001/01/01',
        change_reason: 0,
        matching_month: '',
        state: 1,
        charge_person: 0,
        decision_person: 0,
        seven_days_tel: 0,
        ten_days_tel: 0,
        fourteen_days_tel: 0,
        document: 0,
        first_day_limit: '0001/01/01',
        first_day_check: 0,
        first_day: '0001/01/01',
        hold_person: 0,
        family_tel_limit: '0001/01/01',
        tutor_tel_limit: '0001/01/01',
        family_tel_limit_check: 0,
        tutor_tel_limit_check: 0,
        note: '',
        note2: `探し種類：新規・チェンジ

研修：未
研修日：

研修：済
資料発送日：
メール送信日：

探し担当：
決めた日：

教師情報：
大学：
学部：
学年：
年齢：
携帯：
自宅：
印象：
経験：
ランナーでの経験：
仕事：

指導条件
曜日：
時間帯：
指導開始時期：

移動
交通手段：
交通費：

特記事項
最低一年間：
帰省：

備考：

資料到着確認担当：
資料到着日：
届いた連絡：

紹介担当：
紹介TEL：
教師から家庭に連絡を何日までに入れさせる：
待機させる：
備考：
教師に実際何日までに家庭に電話するように伝えた：
初回指導日：

前任対応：
前任処理：`,

        // 表示だけpostしない
        tel1: '',
        tel2: '',
        name: '',
        kana: ''
      },

      search: {
        id: '',
        tel1: '',
        tel2: '',
        name: '',
        kana: ''
      }
    }
  },
  computed: {
    students () {
      return this.$store.getters.students
    }

    // filteredStudents () {
    //   let self = this
    //   return self.students.filter((student) => {
    //     if (user.id !== 0) {
    //       return user.hide_flag === 0
    //     }
    //   })
    // }
  },
  watch: {
  },
  methods: {
    showModal () {
      this.condition.condition = !this.condition.condition
    },

    push (list) {
      this.student_tutor.student_id = list.id
      this.student_tutor.tel1 = list.family.tel1
      this.student_tutor.tel2 = list.family.tel2
      this.student_tutor.name = list.f_name + list.l_name
      this.student_tutor.kana = list.f_name_kana + list.l_name_kana
    },

    // searchTable (e) {
    //   this.$store.dispatch('SEARCH', {
    //     this: this,
    //     e: e,
    //     obj: obj
    //   })
    // },

    searchTable (e) {
      let search = this.search
      var store = this.$store
      var params = {}
      function searchTable () {
        // students
        var paramsList = [
          'id',
          'tel1',
          'tel2',
          'name',
          'kana'
        ]
        paramsList.forEach(function (e) {
          if (search[e]) {
            params[e] = search[e]
          }
        })
        axios.get(obj.url, {params: params, withCredentials: true})
        .then(response => {
        // success callback
          // console.log(response)
          store.state.list.students = response.data.student
          store.state.max = response.data.max
          obj.searchUrl = response.request.responseURL
          obj.COUNT = 1
        }, (response) => {
        // error callback
        })
      }

      if (obj.TIMER) {
        clearTimeout(obj.TIMER)
        obj.TIMER = setTimeout(searchTable, obj.wait)
        return
      }
      obj.TIMER = setTimeout(searchTable, obj.wait)
    },

    postST () {
      if (this.student_tutor.student_id) {
        this.$store.dispatch('postST', {
          student_tutor: this.student_tutor,
          condition: this.condition,
          modal: this.modal
        })
      } else {
        alert('生徒を選択して下さい。')
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang='scss' scoped>
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
.wrapper {
  display: flex;
  flex-flow: column;
  max-height: 340px;
}
.mail-list {
  overflow: scroll;
  margin: 5px 0;
}
.table {
  margin: 0;
}
.footer {
  width: 100%;
  display: flex;
  .m-btn + .m-btn {
    margin-top: 0;
  }
}
</style>

<style lang="scss">
.student_tutorsAdd {
}
</style>



// WEBPACK FOOTER //
// Student_tutorsAdd.vue?9d9a5a04